import { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

export default function FAQs() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "How do I place an order?",
      answer: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
    {
      question: "What payment methods do you accept?",
      answer: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
    {
      question: "How long does shipping take?",
      answer: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
    {
      question: "Can I cancel my order?",
      answer: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
    {
      question: "What is your return policy?",
      answer: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
    {
      question: "How do I track my order?",
      answer: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faqs-page">
      <div className="faqs-container">
        {/* Header */}
        <div className="faqs-header">
          <h1>Frequently Asked Questions</h1>
          <p>Find answers to common questions about our products and services.</p>
        </div>

        {/* FAQ List */}
        <div className="faqs-list">
          {faqs.map((faq, index) => (
            <div key={index} className="faqs-item">
              <button 
                className="faqs-question"
                onClick={() => toggleFAQ(index)}
              >
                <span>{faq.question}</span>
                {openIndex === index ? (
                  <ChevronUp className="faqs-icon" />
                ) : (
                  <ChevronDown className="faqs-icon" />
                )}
              </button>

              {openIndex === index && (
                <div className="faqs-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Contact Section */}
        <div className="faqs-contact">
          <h2>Still have questions?</h2>
          <p>Can't find the answer you're looking for? Please contact our support team.</p>
          <button className="faqs-contact-btn">Contact Support</button>
        </div>
      </div>
    </div>
  );
}